import React, { Component } from 'react';
import ComponentIcon from '@material-ui/icons/Cancel';

class CancelIcon extends Component {
  render() {
    return <ComponentIcon {...this.props} />;
  }
}

export default CancelIcon;
